import React from "react";

import '../styles/StarBackground.css';

export default function StarBackground(){
    return(
            <div class="bg-animation">
                <div id="stars"></div>
                <div id="stars2"></div>
                <div id="stars3"></div>
                <div id="stars4"></div>
            </div>
    );
}